import { Type } from "class-transformer";
import { AbstractJSONModel } from "./master-model";

export enum AbsenceRequestState {
  Pending = "Pending",
  Approved = "Approved",
  Rejected = "Rejected"
}

export interface SelectedOption {
  label: string;
  value: string;
}

export interface AbsenceRequestOption {
  option_name: string;
  selected_options: SelectedOption[];
}

export interface IAbsenceRequest {
  absence_id: number | null;
  external_id: string;
  origin: number;
  person_external_id: string;
  absence_type_external_id: string;
  absence_type_name: string;
  start_date: Date;
  end_date: Date;
  start_time: number | null;
  end_time: number | null;
  is_open: boolean;
  substitute_planner_note: string;
  institution_external_id: string;
  state: AbsenceRequestState;
  created_at: Date;
  updated_at: Date | null;
  manager_note: string;
  created_by_external_id: string;
  updated_by_external_id: string | null;
  selected_options: AbsenceRequestOption[];
  reported: boolean;
}

export interface IAbsenceRequestPut {
  external_id: string;
  absence_type_external_id: string;
  absence_type_name: string;
  start_date: string;
  end_date: string;
  start_time: number | null;
  end_time: number | null;
  state: AbsenceRequestState;
  is_open: boolean;
}

export class AbsenceRequest extends AbstractJSONModel implements IAbsenceRequest {
  public absence_id: number | null = null;
  public external_id: string = "";
  public origin: number = 0;
  public person_external_id: string = "";
  public absence_type_external_id: string = "";
  public absence_type_name: string = "";
  @Type(() => Date)
  public start_date: Date = new Date();
  @Type(() => Date)
  public end_date: Date = new Date();
  public start_time: number | null = null;
  public end_time: number | null = null;
  public substitute_planner_note: string = "";
  public institution_external_id: string = "";
  public state: AbsenceRequestState = AbsenceRequestState.Pending;
  @Type(() => Date)
  public created_at: Date = new Date();
  @Type(() => Date)
  public updated_at: Date | null = null;
  public manager_note: string = "";
  public created_by_external_id: string = "";
  public updated_by_external_id: string | null = null;
  public selected_options: AbsenceRequestOption[] = [];
  public reported: boolean = false;
  public is_open: boolean = false;

  public convertToPutObject(): IAbsenceRequestPut {
    const ap: IAbsenceRequestPut = Object.assign({});
    ap.external_id = this.external_id;
    ap.absence_type_external_id = this.absence_type_external_id;
    ap.absence_type_name = this.absence_type_name;
    ap.start_date = this.start_date.toISOString();
    ap.end_date = this.end_date.toISOString();
    ap.start_time = this.start_time;
    ap.end_time = this.end_time;
    ap.state = this.state;
    ap.is_open = this.is_open;
    return ap;
  }
}
